<!--赖传峰-->
<!--2022/1/24-->
<!--eslint-disable max-len-->
<template>
  <DriveFeatureSVGSlot>
    <path
      :fill="props.color"
      clip-rule="evenodd"
      d="M25.4758 48.2387C25.3624 48.7981 24.8706 49.2002 24.2998 49.2002H21.9379C21.1565 49.2002 20.5835 48.4653 20.7742 47.7075L26.2072 26.1075C26.3414 25.5741 26.821 25.2002 27.371 25.2002H30.1182C30.6682 25.2002 31.1478 25.5741 31.2819 26.1075L36.715 47.7075C36.9056 48.4653 36.3326 49.2002 35.5512 49.2002H33.1894C32.6185 49.2002 32.1267 48.7981 32.0133 48.2387L31.6445 46.4201C31.5311 45.8607 31.0393 45.4586 30.4685 45.4586H27.0207C26.4499 45.4586 25.958 45.8607 25.8446 46.4201L25.4758 48.2387ZM29.09 41.144C29.8491 41.144 30.4175 40.4481 30.2658 39.7043L29.9208 38.0122C29.6598 36.7319 27.8303 36.7319 27.5692 38.0122L27.2243 39.7043C27.0726 40.4481 27.641 41.144 28.4001 41.144H29.09ZM44.7023 49.2002C47.3413 49.2002 48.7927 48.1215 49.8483 46.8744C51.4693 44.9565 51.5948 41.4855 51.5986 38.5561L51.5979 37.8645L51.5971 37.5286L51.5967 37.2002C51.5967 37.01 51.5972 36.8156 51.5977 36.6175L51.5979 36.5358L51.5986 35.8443C51.5948 32.9149 51.4693 29.4439 49.8483 27.526C48.7927 26.2788 47.3413 25.2002 44.7023 25.2002H39.2717C38.609 25.2002 38.0717 25.7375 38.0717 26.4002V48.0002C38.0717 48.6629 38.609 49.2002 39.2717 49.2002H44.7023ZM43.9554 44.8856H44.6027C45.4604 44.8856 46.0542 44.4474 46.3511 43.8406C46.9119 42.7283 46.9119 39.8294 46.9119 37.1665C46.9119 34.5036 46.9119 31.6721 46.3511 30.5597C46.0542 29.953 45.4604 29.5148 44.6027 29.5148H43.9554C43.2927 29.5148 42.7554 30.0521 42.7554 30.7148V43.6856C42.7554 44.3483 43.2927 44.8856 43.9554 44.8856Z"
      fill-rule="evenodd"
    />
    <rect
      fill="white"
      height="3.6"
      rx="1.8"
      transform="rotate(-45 20.6523 51.8008)"
      width="43.2"
      x="20.6523"
      y="51.8008"
    />
  </DriveFeatureSVGSlot>
</template>

<script
  lang="ts"
  setup
>
import IconPropsType from '@/components/icons/iconPropsType'
import DriveFeatureSVGSlot from './PremiumRightsSVGSlot.vue'

const props = defineProps({ color: IconPropsType.color })
</script>
